<template>
    <div class="indexPage" style="height: 100%;overflow-x: hidden;">

        <headfix></headfix>
        <div class="common-banner search-banner">
            <div class="bg-img" v-for="(item,index) in advList">
                <img :src="item.advImages" class="pc" @click="goAdv_(item)"/>
                <img :src="item.advSmallImages1" class="mobile" @click="goAdv_(item)"/>
            </div>

            <div class="banner-txt">
                <div class="wraper-box">
                    <div class="search-title">搜索</div>
                    <div class="search-input-box">
                        <input type="text" placeholder="输入想要搜索的内容" v-model="keywords" @keyup.enter="searchSubmit()"/>
                        <div class="search-btn" @click="searchSubmit"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="wraper-box" style="position: relative;">
            <div class="art-list" v-if="articleList.length>0">
                <a class="art-item" v-for="(item,index) in articleList" @click="goArticleDetail(item)">
                    <div class="art-no">{{index < 9 ? "0" + (index + 1) : (index + 1)}}</div>
                    <div class="art-title">
                        <div class="t1">{{item.title}}</div>
                        <div class="t2">{{item.keywords}}</div>
                    </div>
                    <div class="art-time">{{item.createTime | getMyDate}}</div>
                    <i class="icon"></i>
                </a>
                <div class="clearfix"></div>
            </div>

            <div class="search-word" v-else>您的查询<span>“{{keywords1}}”</span>找到<strong> 0 </strong>个结果</div>

        </div>
<!--        <footerfix></footerfix>-->


    </div>
</template>
<script>
    import headfix from '@/components/utils/headfix';
    import footerfix from '@/components/utils/footerfix';
    import playervideo from '@/components/utils/playervideo';
    import {settingInfo_, categoryTree_, goCate_, goAdv_} from '@/components/js/app'

    export default {
        components: {headfix, footerfix, playervideo},
        data() {
            return {
                page: 1,
                pageSize: 100,
                keywords: '',
                keywords1: '',
                categoryList: [],
                advList: [],
                articleList: [],
            }
        },
        mounted() {
            document.querySelector('body').setAttribute('style', 'background-color:#faf9f5')
        },
        created() {
            this.$nextTick(() => {
                this.getAdvData(67);
            })
        },
        methods: {
            goCate_,
            goAdv_,
            // 分类广告
            getAdvData(positionId) {
                this.$post_('api/adv/adv-list', {catId: positionId}, (res) => {
                    if (res.code == 1) {
                        this.advList = res.data;
                    } else {
                        this.$message.error(res.message);
                    }
                })
            },
            // 文章列表
            getArticleListData() {
                if (!this.keywords1) {
                    return;
                }
                let data = {
                    title: this.keywords1
                }
                this.$post_('api/cms-article/article-page', {
                    page: this.page,
                    size: this.pageSize,
                    data: data
                }, (res) => {
                    if (res.code == 1) {
                        this.articleList = res.data.records;
                        this.total = Number(res.data.total);
                    } else {
                        this.$message.error(res.message);
                    }
                })
            },
            goArticleDetail(item) {
                if (item.modelId == 5) {
                    this.$router.push({path: '/case', query: {cateId: 45}});
                } else if (item.modelId == 4) {
                    this.$router.push({path: '/productDetail', query: {cateId: item.categoryId, id: item.id}});
                } else {
                    this.$router.push({path: '/articleDetail', query: {cateId: item.categoryId, id: item.id}});
                }
            },
            searchSubmit() {
                this.keywords1 = this.keywords;
                this.getArticleListData();
                this.keywords=''
            }
        }
    }
</script>

<style scoped>
    .common-banner.search-banner{height: 31.25vw;}
    .banner-txt{position: absolute;left: 0;width: 100%;top: 50%;transform: translateY(-50%);color: #fff;}
    .search-title{line-height: 75px;font-size: 38px;color: #FFF;text-align: center;}
    .search-input-box{background: #FFF;height: 62px;margin: 22px 0px;position: relative;}
    .search-input-box input{height: 62px;width: 100%;padding: 0px 82px 0px 25px;color: #333;font: 18px/62px "微软雅黑";outline: 0;border: 0;}
    .search-input-box .search-btn{background: url(../../assets/img/top_search.png) no-repeat center center;display: inline-block;height: 62px;width: 84px;position: absolute;top: 0px;right: 0px;cursor: pointer;border: none;background-size: 30px auto;}

    .art-list {
        margin-top: 50px;
        margin-bottom: 100px;
    }

    .art-list .art-item {
        display: flex;
        border-bottom: #CCCCCC 1px solid;
        padding: 20px 0px 20px 0px;
        position: relative;
    }

    .art-item .art-no {
        width: 50px;
        font-size: 28px;
        color: #CCCCCC;
    }

    .art-item .art-title {
    }

    .art-item .art-title .t1 {
        font-size: 20px;
        font-weight: 500;
        color: #000000;
    }

    .art-item .art-title .t2 {
        font-size: 12px;
        color: #555555;
    }

    .art-item .art-time {
        position: absolute;
        right: 40px;
        top: 30px;
    }

    .art-item .icon {
        position: absolute;
        right: 0px;
        top: 30px;
        background: url(../../assets/img/article_icon.png) no-repeat center center;
        width: 31px;
        height: 22px;
    }

    .search-word {
        font-size: 18px;
        line-height: 32px;
        margin-top: 100px;
        margin-bottom: 100px;
    }

    .search-word span {
        color: #FF0000;
    }


    /*产品中心-筛选*/

    @media (max-width: 1799px) {

    }

    @media (max-width: 1199px) {

    }

    @media (max-width: 993px) {
        .banner-txt{top: 40%;}
        .wraper-box{padding: 0px 30px;}
        .common-banner.search-banner{height: 380px;}
    }

    @media (max-width: 767px) {
        .art-item .art-time{display: none;}
        .art-item .icon{display: none;}
        .art-item .art-no{font-size: 18px;width: 40px;}
        .item-left .item-title{font-size: 14px;}
        .art-item .art-title .t1{font-size: 14px;}
    }


</style>
